var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccomodationTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Base"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.001 12.1591H40.001C43.3147 12.1591 46.001 14.8453 46.001 18.1591V38.1591C46.001 41.4728 43.3147 44.1591 40.001 44.1591H8.00098C4.68727 44.1591 2.00098 41.4728 2.00098 38.1591V18.1591C2.00098 14.8453 4.68727 12.1591 8.00098 12.1591H14.001V10.1591C14.001 6.84535 16.6873 4.15906 20.001 4.15906H28.001C31.3147 4.15906 34.001 6.84535 34.001 10.1591V12.1591ZM34.001 40.1591H40.001C41.1055 40.1591 42.001 39.2636 42.001 38.1591V18.1591C42.001 17.0545 41.1055 16.1591 40.001 16.1591H34.001V40.1591ZM30.001 16.1591V40.1591H18.001V16.1591H30.001ZM18.001 12.1591V10.1591C18.001 9.05449 18.8964 8.15906 20.001 8.15906H28.001C29.1055 8.15906 30.001 9.05449 30.001 10.1591V12.1591H18.001ZM14.001 16.1591H8.00098C6.89641 16.1591 6.00098 17.0545 6.00098 18.1591V38.1591C6.00098 39.2636 6.89641 40.1591 8.00098 40.1591H14.001V16.1591Z",
    fill: "#15D4B6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccomodationTravel);
export default __webpack_public_path__ + "static/media/iconAccomodationTravel.d5a38e7b51ae63df610f422333703c54.svg";
export { ForwardRef as ReactComponent };